import { LabelValueRow } from 'components/core-v2'

export const Loading = () => (
  <>
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
    <LabelValueRow isLoading />
  </>
)
